
















































































































import {Component, Provide, Vue, Watch} from 'vue-property-decorator';
import {mapActions} from 'vuex';
import {API} from '@/services/api/api';
import {VueEditor} from 'vue2-editor';
import EmailConfig from '@/models/emailconfig';
import CButton from '@/components/Button.vue';
import FormInput from '@/components/FormInput.vue';
import validator from '@/utils/validator';
import validationMsgs from '@/constants/validation';
import {redirectTime} from '@/constants/constants';
import {dynamicValues} from '@/services/email-config.ts';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  components: {CButton, FormInput, VueEditor},
})
export default class EditEmailConfig extends Vue {
  emailConfigId;
  emailConfig: EmailConfig = {
    body: '',
    senderName: '',
    configurationFor: '',
    dynamicValue: '',
    subjectLine: '',
    isActive: false,
  };

  //loader and helper variables
  isScreenLoading = true;
  saving = false;
  showSuccessToast: any;
  showErrorToast: any;

  //validation variables
  nameValidationMsg = null;
  configForValidationMsg = null;
  subjectLineValidationMsg = null;
  bodyValidationMsg = null;
  dynamicValueValidationMsg = null;

  configForList = [
    {
      id: 'Inspection',
      name: 'Inspection',
    },
    {
      id: 'Surveyor',
      name: 'Surveyor',
    },
  ];
  dynamicValueList = dynamicValues;

  mounted() {
    this.emailConfigId = this.$route.params.id;
    this.getEmailConfig();
  }

  //validation functions
  validateSenderName() {
    const senderName = this.emailConfig.senderName;
    if (validator.isNullOrEmpty(senderName)) {
      this.nameValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.nameValidationMsg = null;
      return true;
    }
  }
  validateConfigFor() {
    const config = this.emailConfig.configurationFor;
    if (validator.isNullOrEmpty(config)) {
      this.configForValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.configForValidationMsg = null;
      return true;
    }
  }
  validateSubjectLine() {
    const subject = this.emailConfig.subjectLine;
    if (validator.isNullOrEmpty(subject)) {
      this.subjectLineValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.subjectLineValidationMsg = null;
      return true;
    }
  }
  validateDyanmicValue() {
    const value = this.emailConfig.dynamicValue;
    if (validator.isNullOrEmpty(value)) {
      this.dynamicValueValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.dynamicValueValidationMsg = null;
      return true;
    }
  }
  validateBody() {
    const body = this.emailConfig.body;
    if (validator.isNullOrEmpty(body)) {
      this.bodyValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.bodyValidationMsg = null;
      return true;
    }
  }
  validateAll() {
    return (
      this.validateSenderName() &&
      this.validateConfigFor() &&
      this.validateSubjectLine() &&
      this.validateDyanmicValue() &&
      this.validateBody()
    );
  }

  async getEmailConfig() {
    try {
      let response = await API.getEmailConfigById(this.emailConfigId);
      this.isScreenLoading = false;
      if (response.data !== '' && response.data !== null) {
        let data: EmailConfig = response.data;
        this.emailConfig = data;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  async onSubmitClick() {
    if (!this.validateAll()) return false;
    this.saving = true;
    try {
      const response = await API.updateEmailConfig(this.emailConfigId, this.emailConfig);
      this.saving = false;
      if (response.data) {
        this.showSuccessToast({msg: 'Record updated'});
        setTimeout(() => this._clickHandler(), redirectTime);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (e) {
      this.saving = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  _clickHandler() {
    this.$router.go(-1);
  }

  onAddClick() {
    if (!this.emailConfig.dynamicValue) return;
    this.emailConfig.body += `#${this.emailConfig.dynamicValue}#`;
  }
}
